import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cryptoApiHeaders = {
  "X-RapidAPI-Key": "e7df2cc4f2mshbd4ceadd0fee61ap12a7c9jsnc3dddb3e0058",
  "X-RapidAPI-Host": "coinlore-cryptocurrency.p.rapidapi.com",
};
const baseUrl = "https://coinlore-cryptocurrency.p.rapidapi.com";

const createRequest = (url) => ({ url, headers: cryptoApiHeaders });

export const cryptoApi = createApi({
  reducerPath: "cryptoApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getCryptos: builder.query({
      query: () => createRequest("/api/global/"),
    }),
  }),
});

export const { useGetCryptosQuery } = cryptoApi;
